import { apiSlice } from './apiSlice'

export const settingsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getDepartments: builder.query({
      query: () => '/v1/settings/departments',
      providesTags: ['Departments']
    }),
    getCountries: builder.query({
      query: () => '/v1/settings/countries',
      providesTags: ['Countries']
    }),
    getLanguages: builder.query({
      query: () => '/v1/settings/languages',
      providesTags: ['Languages']
    }),
    getSystemRoles: builder.query({
      query: () => '/v1/settings/system-roles',
      providesTags: ['SystemRoles'],
      transformResponse: response => response.data.map(role => ({ label: role.name, value: role.id }))
    }),
    getSamlProviders: builder.query({
      query: () => '/v1/saml/configurations',
      providesTags: ['SamlProviders']
    }),
    addSamlProvider: builder.mutation({
      query: () => ({
        url: '/v1/saml/configurations',
        method: 'POST',
        body: {}
      }),
      invalidatesTags: ['SamlProviders']
    }),
    updateSamlProvider: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/v1/saml/configurations/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['SamlProviders']
    }),
    getOneSamlProvider: builder.query({
      query: id => `/v1/saml/configurations/${id}`,
      providesTags: ['SamlProviders']
    }),
    activateSamlProvider: builder.mutation({
      query: id => ({
        url: `/v1/saml/configurations/${id}/activate`,
        method: 'POST'
      }),
      invalidatesTags: ['SamlProviders']
    }),
    deactivateSamlProvider: builder.mutation({
      query: id => ({
        url: `/v1/saml/configurations/${id}/deactivate`,
        method: 'POST'
      }),
      invalidatesTags: ['SamlProviders']
    })
  })
})

export const {
  useGetDepartmentsQuery,
  useGetCountriesQuery,
  useGetLanguagesQuery,
  useGetSystemRolesQuery,
  useGetSamlProvidersQuery,
  useAddSamlProviderMutation,
  useUpdateSamlProviderMutation,
  useLazyGetOneSamlProviderQuery,
  useActivateSamlProviderMutation,
  useDeactivateSamlProviderMutation
} = settingsApi
